export const userTypes = {
  ADMIN: "admin",
  DATAMANAGER: "data_manager",
  CALLCENTER: "call_center",
};
